import { Container, Heading, Stack, Text } from '@chakra-ui/react'
import { SelectedOrgChecker } from '@features/organisations/components/SelectedOrgChecker'
import { createFileRoute } from '@tanstack/react-router'

const DataEventAutomationsRoute = () => (
  <Container maxW={'75rem'}>
    <SelectedOrgChecker>
      <Stack spacing={4}>
        <Heading size="lg">Automations</Heading>
        <Heading size="md">Data Events</Heading>
        <Text color={'muted'}>
          Data event automation operations will be shown here.
        </Text>
      </Stack>
    </SelectedOrgChecker>
  </Container>
)

export const Route = createFileRoute('/_auth/o/$orgId/automations/dataEvents')({
  component: DataEventAutomationsRoute,
  beforeLoad: () => ({ getTitle: () => 'Data Event Automations' }),
  loader: () => ({
    crumb: 'Data Events',
  }),
})
